/** Structural abort check (no runtime imports): true for a `DOMException` AbortError or any `{ code: "aborted" }` object — neither is a real error. */
export function isAbortError(err: unknown): boolean {
  if (err instanceof DOMException && err.name === "AbortError") return true;
  return typeof err === "object" && err !== null && (err as { code?: unknown }).code === "aborted";
}
